import DuplicateError from '../validation_errors/duplicate_validator_error.js';

export default angular.module('BaseClass.validatable.validators',[
    DuplicateError
])
    .factory('BCvalidators', function(BCVDuplicateValidatorError) {
        var validators = {};

        validators.register = function(validator) {
            if (_.isUndefined(validators[validator.name])) validators[validator.name] = validator;
            else throw new BCVDuplicateValidatorError(validator.name);
        };

        validators.find = function(validatorName) {
            return validators[validatorName];
        };

        return validators;
    }).name;

